module.exports = __webpack_public_path__ + "static/media/img3-2.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/nutricheck_foliar/K/img3-2.png
// module id = 2247
// module chunks = 3